module.exports = __webpack_public_path__ + "pivotaltracker-logo.png";